import { Injectable } from '@angular/core';

import { keyBy } from 'lodash-es';
import { Option } from 'packages/sports/web/app/src/tokens-base/token-base.models';

import { BetslipType } from '../../../../../core/betslip-type';
import { BetslipPick } from '../../../../../core/picks/betslip-pick';
import { BetslipV1Pick } from '../../../../../core/picks/betslip-v1-pick';
import { BetslipV2OptionMarketPick } from '../../../../../core/picks/betslip-v2-option-market-pick';
import { CriteriaType, IRewardToken } from '../../../reward-tokens.model';
import { TokenPicksValidity, TokenValidationInput, TokensCriteriaValidatorBase } from '../criteria-validator-base.service';

@Injectable()
export class OptionValidator extends TokensCriteriaValidatorBase<IRewardToken, CriteriaType> {
    override type = CriteriaType.OptionId;
    isValid(token: IRewardToken, state: TokenValidationInput): TokenPicksValidity {
        const picks = state.selectedPicks;

        if (token.filter?.options?.length) {
            const eligibleOptionIds = keyBy(token.filter.options, (option) => option.id);
            const validPicks = picks.filter((pick) => this.isValidPick(pick, eligibleOptionIds));

            const isValid =
                state.selectedType === BetslipType.Single || state.selectedType === BetslipType.BetBuilder
                    ? !!validPicks.length
                    : validPicks.length === picks.length;

            return { isValid, validPicksIds: validPicks.map((p) => p.id.toString()) };
        }

        return { isValid: true, validPicksIds: picks.map((p) => p.id.toString()) };
    }

    private isValidPick(pick: BetslipPick, eligibleOptionIds: { [id: number]: Option }): boolean {
        if (pick instanceof BetslipV1Pick || pick instanceof BetslipV2OptionMarketPick) {
            return !!eligibleOptionIds[pick.option.id];
        }

        return false;
    }
}
